export interface NaicsVendorCategory {
  code: string;
  title: string;
  category: string;
  ccna: boolean;
}

export const NAICS_VENDOR_CATEGORIES: readonly NaicsVendorCategory[] = [
  {
    code: '236220',
    title: 'Commercial and Institutional Building Construction',
    category: 'Construction - Vertical / Buildings',
    ccna: false,
  },
  {
    code: '236116',
    title: 'New Multifamily Housing Construction',
    category: 'Construction - Vertical / Buildings',
    ccna: false,
  },
  {
    code: '236115',
    title: 'New Single-Family Housing Construction',
    category: 'Construction - Vertical / Buildings',
    ccna: false,
  },
  {
    code: '236117',
    title: 'New Housing For-Sale Builders',
    category: 'Construction - Vertical / Buildings',
    ccna: false,
  },
  {
    code: '237310',
    title: 'Highway, Street, and Bridge Construction',
    category: 'Construction - Heavy / Civil & Infrastructure',
    ccna: false,
  },
  {
    code: '237110',
    title: 'Water and Sewer Line and Related Structures Construction',
    category: 'Construction - Heavy / Civil & Infrastructure',
    ccna: false,
  },
  {
    code: '237990',
    title: 'Other Heavy and Civil Engineering Construction',
    category: 'Construction - Heavy / Civil & Infrastructure',
    ccna: false,
  },
  {
    code: '237210',
    title: 'Land Subdivision',
    category: 'Construction - Heavy / Civil & Infrastructure',
    ccna: false,
  },
  {
    code: '238910',
    title: 'Site Preparation Contractors',
    category: 'Specialty Trades',
    ccna: false,
  },
  {
    code: '238990',
    title: 'All Other Specialty Trade Contractors',
    category: 'Specialty Trades',
    ccna: false,
  },
  {
    code: '238110',
    title: 'Poured Concrete Foundation and Structure Contractors',
    category: 'Specialty Trades',
    ccna: false,
  },
  {
    code: '238210',
    title: 'Electrical Contractors',
    category: 'Specialty Trades',
    ccna: false,
  },
  {
    code: '238220',
    title: 'Plumbing, Heating, and Air-Conditioning Contractors',
    category: 'Specialty Trades',
    ccna: false,
  },
  {
    code: '238320',
    title: 'Painting and Wall Covering Contractors',
    category: 'Specialty Trades',
    ccna: false,
  },
  {
    code: '236118',
    title: 'Residential Remodelers',
    category: 'Housing Repair & Rehabilitation',
    ccna: false,
  },
  {
    code: '238350',
    title: 'Finish Carpentry Contractors',
    category: 'Housing Repair & Rehabilitation',
    ccna: false,
  },
  {
    code: '238330',
    title: 'Flooring Contractors',
    category: 'Housing Repair & Rehabilitation',
    ccna: false,
  },
  {
    code: '238160',
    title: 'Roofing Contractors',
    category: 'Housing Repair & Rehabilitation',
    ccna: false,
  },
  {
    code: '238140',
    title: 'Masonry Contractors',
    category: 'Housing Repair & Rehabilitation',
    ccna: false,
  },
  {
    code: '238310',
    title: 'Drywall and Insulation Contractors',
    category: 'Housing Repair & Rehabilitation',
    ccna: false,
  },
  {
    code: '811490',
    title: 'Other Personal and Household Goods Repair and Maintenance',
    category: 'Handyman Services',
    ccna: false,
  },
  {
    code: '541310',
    title: 'Architectural Services',
    category: 'Architecture, Engineering & Design (A&E)',
    ccna: true,
  },
  {
    code: '541330',
    title: 'Engineering Services',
    category: 'Architecture, Engineering & Design (A&E)',
    ccna: true,
  },
  {
    code: '541320',
    title: 'Landscape Architectural Services',
    category: 'Architecture, Engineering & Design (A&E)',
    ccna: true,
  },
  {
    code: '541370',
    title: 'Surveying and Mapping (except Geophysical)',
    category: 'Architecture, Engineering & Design (A&E)',
    ccna: true,
  },
  {
    code: '541350',
    title: 'Building Inspection Services',
    category: 'Architecture, Engineering & Design (A&E)',
    ccna: false,
  },
  {
    code: '541340',
    title: 'Drafting Services',
    category: 'Architecture, Engineering & Design (A&E)',
    ccna: false,
  },
  {
    code: '541380',
    title: 'Testing Laboratories',
    category: 'Architecture, Engineering & Design (A&E)',
    ccna: false,
  },
  {
    code: '541410',
    title: 'Interior Design Services',
    category: 'Architecture, Engineering & Design (A&E)',
    ccna: false,
  },
  {
    code: '561730',
    title: 'Landscaping Services',
    category: 'Landscaping & Grounds / Road Maintenance',
    ccna: false,
  },
  {
    code: '561790',
    title: 'Other Services to Buildings and Dwellings',
    category: 'Landscaping & Grounds / Road Maintenance',
    ccna: false,
  },
  {
    code: '561210',
    title: 'Facilities Support Services',
    category: 'Landscaping & Grounds / Road Maintenance',
    ccna: false,
  },
  {
    code: '561720',
    title: 'Janitorial Services',
    category: 'Landscaping & Grounds / Road Maintenance',
    ccna: false,
  },
  {
    code: '488490',
    title: 'Other Support Activities for Road Transportation',
    category: 'Landscaping & Grounds / Road Maintenance',
    ccna: false,
  },
  {
    code: '711510',
    title: 'Independent Artists, Writers, and Performers',
    category: 'Public Art & Murals',
    ccna: false,
  },
  {
    code: '541611',
    title: 'Administrative Management and General Management Consulting',
    category: 'Planning, Economic Development & Consulting',
    ccna: false,
  },
  {
    code: '541618',
    title: 'Other Management Consulting Services',
    category: 'Planning, Economic Development & Consulting',
    ccna: false,
  },
  {
    code: '541620',
    title: 'Environmental Consulting Services',
    category: 'Planning, Economic Development & Consulting',
    ccna: false,
  },
  {
    code: '541690',
    title: 'Other Scientific and Technical Consulting Services',
    category: 'Planning, Economic Development & Consulting',
    ccna: false,
  },
  {
    code: '541990',
    title: 'All Other Professional, Scientific, and Technical Services',
    category: 'Planning, Economic Development & Consulting',
    ccna: false,
  },
  {
    code: '611430',
    title: 'Professional and Management Development Training',
    category: 'Business Training & Workforce',
    ccna: false,
  },
  {
    code: '611699',
    title: 'All Other Miscellaneous Schools and Instruction',
    category: 'Business Training & Workforce',
    ccna: false,
  },
  {
    code: '611710',
    title: 'Educational Support Services',
    category: 'Business Training & Workforce',
    ccna: false,
  },
  {
    code: '541810',
    title: 'Advertising Agencies',
    category: 'Marketing, Communications & Events',
    ccna: false,
  },
  {
    code: '541820',
    title: 'Public Relations Agencies',
    category: 'Marketing, Communications & Events',
    ccna: false,
  },
  {
    code: '541613',
    title: 'Marketing Consulting Services',
    category: 'Marketing, Communications & Events',
    ccna: false,
  },
  {
    code: '541430',
    title: 'Graphic Design Services',
    category: 'Marketing, Communications & Events',
    ccna: false,
  },
  {
    code: '541922',
    title: 'Commercial Photography',
    category: 'Marketing, Communications & Events',
    ccna: false,
  },
  {
    code: '541511',
    title: 'Custom Computer Programming Services',
    category: 'Marketing, Communications & Events',
    ccna: false,
  },
  {
    code: '561920',
    title: 'Convention and Trade Show Organizers',
    category: 'Marketing, Communications & Events',
    ccna: false,
  },
  {
    code: '711310',
    title:
      'Promoters of Performing Arts, Sports & Similar Events with Facilities',
    category: 'Marketing, Communications & Events',
    ccna: false,
  },
  {
    code: '722320',
    title: 'Caterers',
    category: 'Marketing, Communications & Events',
    ccna: false,
  },
  {
    code: '339950',
    title: 'Sign Manufacturing',
    category: 'Marketing, Communications & Events',
    ccna: false,
  },
  {
    code: '531210',
    title: 'Offices of Real Estate Agents and Brokers',
    category: 'Real Estate & Appraisal',
    ccna: false,
  },
  {
    code: '531320',
    title: 'Offices of Real Estate Appraisers',
    category: 'Real Estate & Appraisal',
    ccna: false,
  },
  {
    code: '531390',
    title: 'Other Activities Related to Real Estate',
    category: 'Real Estate & Appraisal',
    ccna: false,
  },
  {
    code: '541110',
    title: 'Offices of Lawyers',
    category: 'Legal, Financial & Administrative',
    ccna: false,
  },
  {
    code: '541211',
    title: 'Offices of Certified Public Accountants',
    category: 'Legal, Financial & Administrative',
    ccna: false,
  },
  {
    code: '541219',
    title: 'Other Accounting Services',
    category: 'Legal, Financial & Administrative',
    ccna: false,
  },
  {
    code: '523930',
    title: 'Investment Advice',
    category: 'Legal, Financial & Administrative',
    ccna: false,
  },
  {
    code: '561612',
    title: 'Security Guards and Patrol Services',
    category: 'Legal, Financial & Administrative',
    ccna: false,
  },
  {
    code: '562910',
    title: 'Remediation Services',
    category: 'Environmental / Remediation',
    ccna: false,
  },
];

export function getNaicsVendorCategoryLabel(item: NaicsVendorCategory): string {
  return `${item.code} - ${item.title}`;
}

export function getNaicsVendorCategoryGroups(): {
  category: string;
  items: NaicsVendorCategory[];
}[] {
  return NAICS_VENDOR_CATEGORIES.reduce(
    (groups, item) => {
      const existing = groups.find((group) => group.category === item.category);
      if (existing) {
        existing.items.push(item);
      } else {
        groups.push({ category: item.category, items: [item] });
      }
      return groups;
    },
    [] as { category: string; items: NaicsVendorCategory[] }[],
  );
}
